import * as actionTypes from './actionTypes'

export const onRangeChange = (range) => {
    console.log("-++++++-+-+-+++++-++-*-+-*+*-+-+**-*+-*+-*-*-+-+*-*-+-*-*-*-*");
    
    return {
        type:actionTypes.ON_RANGE_CHANGE,
        range
    }
}


/** WEBPACK FOOTER **
 ** ./src/store/actions/reportCard.js
 **/